import Vue from 'vue'

import nav from './nva'
import from_bottom from './from-bottom'
import tip from './tip'
Vue.component('nav-web', nav)

Vue.component('from-bottom', from_bottom)
Vue.component('tip', tip)




